module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-Bold.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-Bold.eot
// module id = 1890
// module chunks = 0